import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useSpecialDay = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const dryRunGenerate = async year => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/specialDay/generate/${year}`,
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
          params: { dryRun: true },
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const importGenerate = async year => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/specialDay/generate/${year}`,
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
          params: { dryRun: false },
        });
        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  return {
    isLoading,
    error,
    dryRunGenerate,
    importGenerate,
  };
};

export default useSpecialDay;
